import { Controller } from '@hotwired/stimulus'
import { loadMercadoPago } from '~/lib/mercado_pago_sdk'

// Upsell com cartão salvo: só o CVV (Secure Field) gera um token novo a
// partir do card_id salvo no customer do MP. Sem public key (mock) não faz nada.
export default class extends Controller {
  static targets = ['securityCode', 'token']
  static values = { publicKey: String, cardId: String }

  async connect() {
    if (!this.publicKeyValue || !this.hasSecurityCodeTarget) return
    this.mp = await loadMercadoPago(this.publicKeyValue)
    this.mp.fields.create('securityCode', { placeholder: 'CVV' }).mount(this.securityCodeTarget.id)
  }

  async submit(event) {
    if (!this.mp || this.tokenTarget.value) return
    event.preventDefault()
    try {
      const token = await this.mp.fields.createCardToken({ cardId: this.cardIdValue })
      if (!token?.id) throw new Error('Confira o CVV.')
      this.tokenTarget.value = token.id
      this.element.requestSubmit()
    } catch (error) {
      window.alert(error?.message || 'Confira o CVV.')
    }
  }
}
